import { render, staticRenderFns } from "./OrticVueSummernote.vue?vue&type=template&id=7d8d61a0"
import script from "./OrticVueSummernote.vue?vue&type=script&lang=js"
export * from "./OrticVueSummernote.vue?vue&type=script&lang=js"
import style0 from "./OrticVueSummernote.vue?vue&type=style&index=0&id=7d8d61a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports